<div class="registration-with-code-qrcode-combined">

    <sc-flex vertical stretchContent>
      <sc-padding>
          <sc-title>
            <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-with-code.headline"></sc-dictionary-label>
          </sc-title>
      </sc-padding>

      <sc-flex stretchContent fitHeight>
        <sc-flex-fitting-content>
          <sc-padding>
            <div *ngIf="!qrCodeScanEnabled">
              <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-with-code.description"></sc-dictionary-label>
            </div>

            <div *ngIf="qrCodeScanEnabled">
              <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-with-code.description-with-scanning"></sc-dictionary-label>
            </div>

            <sc-sub-title>
              <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-with-code.code.headline"></sc-dictionary-label>
            </sc-sub-title>

            <form [formGroup]="registrationForm" class="form">
              <mat-form-field class="registration-code" appearance="fill">
                <mat-label>Code</mat-label>
                <input matInput #focusComponent formControlName="code" autofocus>
              </mat-form-field>
            </form>

            <app-service-response [responseMessages]="responseMessages"></app-service-response>
            <ng-container *ngIf="validationMessage != null">
              <sc-sub-title>
                <sc-dictionary-label [dictionaryKey]="validationMessage.message"></sc-dictionary-label>
              </sc-sub-title>
              <sc-content-spacer vertical></sc-content-spacer>
            </ng-container>
            <mat-spinner class="progressSpinner" *ngIf="checkCodeActive"></mat-spinner>

          </sc-padding>
        </sc-flex-fitting-content>

        <div *ngIf="qrCodeScanEnabled">
          <sc-padding>
            <div class="qrcode" *ngIf="scannerType != 'webcam'">
              <img src="/assets/default/terminal_scan_qrcode_2.svg">
              <div class="diode">
                <div class="laser"></div>
              </div>
            </div>

            <div class="qrcode" *ngIf="scannerType === 'webcam' && webCamScannerEnabled">
              <zxing-scanner #scanner [enable]="webCamScannerEnabled"
                    [device]="deviceCurrent"
                    [autostart]="true"
                    (camerasFound)="camerasFoundHandler($event)"
                    (permissionResponse)="onCameraPermission($event)"
                    (deviceChange)="onCameraDeviceChanged($event)"
                    (scanSuccess)="scanSuccessHandler($event)"
                    (scanError)="scanErrorHandler($event)"
                    (scanComplete)="scanCompleteHandler($event)"></zxing-scanner>
            </div>
          </sc-padding>
        </div>

      </sc-flex>

      <div *ngIf="newRegistrationEnabled">
          <p>
            <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-with-code.code.subline"></sc-dictionary-label>
          </p>
      </div>

    </sc-flex>


</div>
